export default __webpack_public_path__ + "static/cabochonsettings-43cd22b3e46e105fa3dc1898a9b34df3.png";